import React, { Component, Fragment } from 'react';

import goodPhoto from '../../images/sign_up/good_photo.png';
import badPhoto from '../../images/sign_up/bad_photo.png';
import Button from '../../artzu-ui/src/Button';

import SubmitImage from './SubmitImage';
import PreviewImage from './PreviewImage';
import Footer from './FooterFixed';
import EncourageScroll from '../EncourageScroll';
import ScrollLock from 'react-scrolllock';

class UploadProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: '',
      errors: '',
      loading: false,
    };
  }

  toggleLoaded = () => this.setState({ loading: !this.state.loading });

  updateSrc = src => this.setState({ src });

  onNextClick = () => this.props.incrementStep();

  onBackClick = () => this.props.decrementStep();

  render() {
    const { currentUser, currentStep, refetch, title } = this.props;
    const { src, loading } = this.state;

    return (
      <Fragment>
        <ScrollLock>
          <EncourageScroll className="apply__profile">
            <div className="apply__profile--container">
              <div className="apply__body--title"> {title}</div>
              <div className="apply__profile--content">
                {' '}
                <div>
                  <p>
                    Please upload a <b>CLEAR</b> photo of your face, and it must be in the center of the photo.
                  </p>
                  <br />
                  <p>Leave some space around your face and shoulders.</p>
                  <br />
                  <p>
                    Do not cover your face; <b>NO</b> sunglasses, <b>NO</b> hats (except religious coverings).
                  </p>
                  <br />
                  <p>
                    <b>Only you</b> in the photo.
                  </p>
                </div>
                <br />
                <div className="apply__profile--guidelines">
                  <div className="apply__profile--examples">
                    <img className="apply__profile--examples-image" src={goodPhoto} alt="good_photo" />{' '}
                    <img className="apply__profile--examples-image" src={badPhoto} alt="bad_photo" />
                  </div>
                </div>
                <br />
              </div>
              <div className="apply__profile--upload">
                <div className="apply__profile--examples--desktop">
                  <img className="apply__profile--examples-image" src={goodPhoto} alt="good_photo" />{' '}
                  <img className="apply__profile--examples-image" src={badPhoto} alt="bad_photo" />
                </div>
                <div className="apply__profile--preview">
                  <PreviewImage
                    image={currentUser ? currentUser.uberProfileImage : null}
                    src={src}
                    category="profile"
                    loading={loading}
                  />
                  <div className="apply__profile--buttons">
                    <Button
                      fullWidth
                      label="Upload"
                      onClick={() => {
                        const input = document.getElementById('edit_photo');
                        input.click();
                      }}
                    />
                    <div className="hide">
                      <Button fullWidth label="Edit" />
                    </div>
                    <SubmitImage
                      toggleLoaded={this.toggleLoaded}
                      type="uber_profile_image"
                      refetch={refetch}
                      updateSrc={this.updateSrc}
                    />
                  </div>
                </div>
              </div>
            </div>
          </EncourageScroll>
        </ScrollLock>
        <Footer
          currentStep={currentStep}
          currentUser={currentUser}
          active={(currentUser.uberProfileImage !== "https://x1.xingassets.com/assets/frontend_minified/img/users/nobody_m.original.jpg" || src) && !loading}
          back
          label="Next"
          onNextClick={this.onNextClick}
          onBackClick={this.onBackClick}
        />
      </Fragment>
    );
  }
}

export default UploadProfile;



// WEBPACK FOOTER //
// ./src/components/TorontoApply/UploadProfile.js